import PepperFlowShowDocument from '../../pages/pepper_flow/ShowDocument';
import PepperFlowTasks from '../../pages/pepper_flow/tasks/Tasks';
import PepperFlowShowTask from '../../pages/pepper_flow/tasks/ShowTask';
import PepperFlowWizard from '../../pages/pepper_flow/wizard/Wizard';

export default [
  {
    path: '/v2/admin/vodori/pepper-flow/connections/:connectionID/document/:documentID',
    name: 'admin.pf.document.show',
    component: PepperFlowShowDocument,
    meta: {
      permission: 'can_edit_presentations',
    },
  },
  {
    path: '/v2/admin/vodori/pepper-flow/tasks',
    name: 'admin.pf.tasks',
    component: PepperFlowTasks,
    meta: {
      permission: 'can_edit_presentations',
    },
  },
  {
    path: '/v2/admin/vodori/pepper-flow/tasks/:taskID(\\d+)',
    name: 'admin.pf.task.show',
    component: PepperFlowShowTask,
    meta: {
      permission: 'can_edit_presentations',
    },
  },
  {
    path: '/v2/admin/vodori/pepper-flow/import',
    name: 'admin.pf.import.wizard',
    component: PepperFlowWizard,
    meta: {
      permission: 'can_edit_presentations',
    },
  }
]
